import React, { Fragment, useContext } from "react";
import {
  getServiceType,
  timeFormat,
  getDwk,
  isEmpty,
  recoverTag,
  getWeekCnt,
} from "bodycodi/cmap/app/js/common";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import {
  DispatchContext as HomeDispatchContext,
  StateContext,
} from "bodycodi/cmap/app/components/cmap2010/home";

import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import edit from "bodycodi/cmap/app/img/edit.png";
import LoadingSpinner from "bodycodi/cmap/app/components/common/loadingSpinner";

type cheduleListWrapProp = {
  isLoading: boolean;
  scheduletList: any;
  selectedDate: number;
  scheduleDate: { year: number; month: number };
  update: Function;
};

type cheduleListProp = {
  d: any;
  update: Function;
};

const ScheduleListWrap = ({
  isLoading,
  scheduletList,
  selectedDate,
  scheduleDate,
  update,
}: cheduleListWrapProp) => {
  if (isLoading) {
    return (
      <div
        className={`schedule-list-wrap empty ${
          getWeekCnt(scheduleDate) === 5 ? "margin-top " : ""
        }`}
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (Object.keys(scheduletList).length === 0) {
    return (
      <div
        className={`schedule-list-wrap empty ${
          getWeekCnt(scheduleDate) === 5 ? "margin-top " : ""
        }`}
      >
        <div className="desc">아직 예약된 스케줄이 없어요</div>
      </div>
    );
  }

  const afterSelectedDates = Object.keys(scheduletList).filter((v) => {
    const date = new Date(v);
    return selectedDate <= date.getDate();
  });
  if (afterSelectedDates.length === 0) {
    return (
      <div
        className={`schedule-list-wrap empty ${
          getWeekCnt(scheduleDate) === 5 ? "margin-top " : ""
        }`}
      >
        <div className="desc">아직 예약된 스케줄이 없어요</div>
      </div>
    );
  }

  const dateList = Object.keys(scheduletList).map((d: string) => {
    const date = new Date(d);
    const toDay = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    const day = Math.floor((date.getTime() - toDay.getTime()) / (1000 * 60 * 60 * 24));

    if (selectedDate > date.getDate()) {
      return <Fragment key={d}></Fragment>;
    }

    const list = scheduletList[d].map((d1: any) => {
      const key =
        d1.scheduleType.toLowerCase() === "class"
          ? "c" + d1.seqPartnerClassSchedule
          : "A" + d1.seqSchedule;

      return (
        <div className="schedule-date-list-wrap" key={key}>
          <ScheduleList d={d1} update={update} />
        </div>
      );
    });

    return (
      <Fragment key={d}>
        <div className="schedule-date-list" data-date={d}>
          {date.getMonth() + 1}. {date.getDate()}. {getDwk(date.getDay())}
          {day === 0 && <span> &#183; 오늘</span>}
          {day === 1 && <span> &#183; 내일</span>}
        </div>
        {list}
      </Fragment>
    );
  });

  return (
    <div className={`schedule-list-wrap ${getWeekCnt(scheduleDate) === 5 ? "margin-top" : ""}`}>
      {dateList}
    </div>
  );
};

const ScheduleList = ({ d, update }: cheduleListProp) => {
  return (
    <>
      {d.scheduleType.toLowerCase() === "appointment" && (
        <ScheduleAppointMent d={d} update={update} />
      )}
      {d.scheduleType.toLowerCase() === "class" && <ScheduleClass d={d} update={update} />}
    </>
  );
};

const ScheduleClass = ({ d, update }: cheduleListProp) => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);
  const startTime = timeFormat(d.startTime);
  const endTime = timeFormat(d.endTime);

  const src = isEmpty(d.memberImgUrl) ? empty : d.memberImgUrl;

  const clickClass = () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        scheduleDtlPop: {
          seqPartner: d.seqPartner,
          seqPartnerBranch: d.seqPartnerBranch,
          seqPartnerCoach: d.seqPartnerCoach,
          seqPartnerClassSchedule: d.seqPartnerClassSchedule,
          scheduleType: d.scheduleType,
          update: update,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: true } });
  };

  return (
    <div className="schedule-list class" onClick={clickClass}>
      <div className={`lesson-time ${d?.closeYn === "Y" ? "auto-close" : ""}`}>
        <div className="bold">
          {startTime.ampm} {startTime.time}
        </div>
        <div className="medium">
          {endTime.ampm} {endTime.time}
        </div>
        <div className="time">{d.scheduleTime}분</div>
      </div>
      <div className="lesson-decs">
        <div className="service-type">
          {getServiceType(d.scheduleType)}

          {d?.closeYn === "Y" ? ( // 폐강 스케줄
            <span className="auto-close-badge">폐강</span>
          ) : (
            <span>
              <span className="black">정원 {d.reservationLimitNo}</span>
              {d.reservationPsblTimeYn === "Y" && (
                <>
                  {d.recruitYn === "Y" && (
                    <>
                      <span className="slash">|</span>
                      <span className="blue">모집중</span>
                    </>
                  )}
                  {d.recruitYn === "N" && (
                    <>
                      <span className="slash">|</span>
                      <span className="green">모집완료</span>
                    </>
                  )}
                </>
              )}
            </span>
          )}
        </div>
        <div className="lesson-name">{recoverTag(d.scheduleName)}</div>
        <div className="partner-name">
          {d.partnerName} {d.partnerBranchName} &#183; {d.spaceName}
        </div>
        <div className="member-info">
          <div className="member">
            {d.reservationNo === 0 && (
              <div className="no-rsrv-member">
                <div className="gray"></div>
                <div className="text">예약한 회원이 없어요.</div>
              </div>
            )}
            {d.reservationNo !== 0 && (
              <>
                <img className="profile" src={src} />
                <div className="name">
                  {d.memberName}
                  {d.reservationNo > 1 && " 외 " + (d.reservationNo - 1) + "명"}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const ScheduleAppointMent = ({ d, update }: cheduleListProp) => {
  const { state } = useContext(StateContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);
  const startTime = timeFormat(d.startDate.split(" ")[1].substring(0, 5));
  const endTime = timeFormat(d.endDate.split(" ")[1].substring(0, 5));

  const src = isEmpty(d.memberImgUrl) ? empty : d.memberImgUrl;

  const clickAppointMent = () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        scheduleDtlPop: {
          seqPartner: d.seqPartner,
          seqPartnerBranch: d.seqPartnerBranch,
          seqPartnerCoach: d.seqPartnerCoach,
          seqSchedule: d.seqSchedule,
          scheduleType: d.scheduleType,
          update: update,
          appointmentClCd: d.appointmentClCd,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: true } });
  };

  return (
    <div
      className={"schedule-list ap" + (d.appointmentClCd === "ET" ? " et" : "")}
      onClick={clickAppointMent}
    >
      <div className="lesson-time">
        <div className="bold">
          {startTime.ampm} {startTime.time}
        </div>
        <div className="medium">
          {endTime.ampm} {endTime.time}
        </div>
        <div className="time">{d.scheduleTime}분</div>
      </div>
      <div className="lesson-decs">
        <div className="service-type">
          {d.appointmentClCd === "OT" && "OT"}
          {d.appointmentClCd === "CS" && "상담"}
          {d.appointmentClCd === "AP" && "개인레슨"}
          {d.appointmentClCd === "ET" && "기타"}
          <>
            {d.scheduleState === "R" && <span className="blue">예약</span>}
            {d.scheduleState === "S" && <span className="green1">출석요청중</span>}
            {d.scheduleState === "E" && <span className="green">출석</span>}
            {d.scheduleState === "A" && <span className="red">결석</span>}
            {d.scheduleState === "C" && <span className="red">취소</span>}
          </>
        </div>
        <div
          className={
            "lesson-name" +
            (d.appointmentClCd === "OT" || d.appointmentClCd === "CS" || d.appointmentClCd === "ET"
              ? " memo"
              : "") +
            (d.appointmentClCd === "ET" && !isEmpty(d.scheduleName) ? " et" : "")
          }
        >
          {(d.appointmentClCd === "OT" ||
            d.appointmentClCd === "CS" ||
            d.appointmentClCd === "ET") && (
            <>
              {isEmpty(d.scheduleName) && (
                <div className={"empty-schedult-memo" + (d.appointmentClCd === "ET" ? " et" : "")}>
                  <img src={edit} className="edit" />
                  <div>입력한 메모가 없어요.</div>
                </div>
              )}
              {!isEmpty(d.scheduleName) && recoverTag(d.scheduleName)}
            </>
          )}
          {d.appointmentClCd === "AP" && recoverTag(d.scheduleName)}
        </div>
        <div className="partner-name">
          {d.partnerName} {d.partnerBranchName}
        </div>
        {d.appointmentClCd !== "ET" && (
          <div className="member-info">
            <div className="member">
              <img className="profile" src={src} />
              <div className="name">{d.memberName}</div>
              {d.seqMember === 0 && <div className="non-member-tag">미회원</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScheduleListWrap;
